import { render, staticRenderFns } from "./ProblemReport.vue?vue&type=template&id=3f82a434&"
import script from "./ProblemReport.vue?vue&type=script&lang=js&"
export * from "./ProblemReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports